/* ============================================================
   th-series-hero.js — EPOMAKER 3.0 Series hero gallery.
   Each row of photos auto-drifts (alternating directions) on a
   seamless, count-agnostic loop and accelerates with scroll velocity
   (GSAP ScrollTrigger.getVelocity). Content reveals on load. Gated on
   prefers-reduced-motion + in-view + tab visibility.
   ============================================================ */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn, { once: true }); }
  ready(function () {
    document.querySelectorAll('[data-ths]').forEach(function (root) {
      if (root.dataset.thsBound) return;
      root.dataset.thsBound = '1';
      (function go(n) {
        if (!window.gsap || !window.ScrollTrigger || !window.TextPlugin) { if (n > 60) return; return setTimeout(function () { go(n + 1); }, 60); }
        gsap.registerPlugin(ScrollTrigger, TextPlugin);
        init(root);
      })(0);
    });
  });

  function init(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    reveal(root, reduce);
    typewriter(root, reduce);

    var tracks = [].slice.call(root.querySelectorAll('[data-ths-track]'));
    var speed = parseFloat(root.getAttribute('data-speed')) || 42;
    var maxBoost = parseFloat(root.getAttribute('data-accel'));
    if (isNaN(maxBoost)) maxBoost = 6;

    function build() {
      var vw = window.innerWidth || 1440;
      var states = [];
      tracks.forEach(function (track, i) {
        // Tile the row until one "copy" is at least the viewport wide, then
        // one more doubling gives a seamless [-half, 0) wrap.
        var guard = 0;
        while (track.scrollWidth < vw * 2 && track.children.length && guard < 12) {
          var kids = [].slice.call(track.children);
          for (var k = 0; k < kids.length; k++) track.appendChild(kids[k].cloneNode(true));
          guard++;
        }
        var half = track.scrollWidth / 2;
        if (half <= 0) return;
        var dir = i % 2 === 0 ? -1 : 1;             // alternate direction
        var pos = -(((i * 0.37) % 1)) * half;        // stagger the start
        track.style.transform = 'translate3d(' + pos + 'px,0,0)';
        states.push({ track: track, half: half, dir: dir, pos: pos });
      });
      return states;
    }

    var states = build();
    if (reduce || !states.length) return;   // static gallery when reduced-motion

    var boost = 1, target = 1, inView = true;
    ScrollTrigger.create({
      trigger: root, start: 'top bottom', end: 'bottom top',
      onUpdate: function (self) { target = 1 + Math.min(Math.abs(self.getVelocity()) / 350, maxBoost); },
      onToggle: function (self) { inView = self.isActive; }
    });

    gsap.ticker.add(function (time, dt) {
      if (!inView || document.hidden) return;
      target += (1 - target) * 0.04;         // decay boost back toward 1
      boost += (target - boost) * 0.08;       // smooth
      var d = (dt || 16) / 1000;
      for (var i = 0; i < states.length; i++) {
        var s = states[i];
        s.pos += s.dir * speed * boost * d;
        if (s.pos <= -s.half) s.pos += s.half;
        else if (s.pos > 0) s.pos -= s.half;
        s.track.style.transform = 'translate3d(' + s.pos + 'px,0,0)';
      }
    });

    // Recompute widths on resize (debounced).
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { states.forEach(function (s) { s.half = s.track.scrollWidth / 2; }); }, 300);
    });
  }

  // Typewriter via GSAP TextPlugin — line 1 types once, then line 2 cycles
  // through its phrases forever (type → hold → delete → next). The blinking
  // caret (CSS ::after on the .is-typing line) rides the active line.
  function typewriter(root, reduce) {
    var p = root.querySelector('[data-ths-type]');
    if (!p) return;
    if (reduce || !window.TextPlugin) return;   // leave the full text in place
    var line1 = p.querySelector('[data-ths-tw]');
    var cycleEl = p.querySelector('[data-ths-cycle]');
    var master = gsap.timeline({ delay: 0.35 });

    if (line1) {
      var t1 = line1.textContent;
      line1.classList.add('is-typing');
      master.fromTo(line1, { text: { value: '' } }, {
        text: { value: t1, delimiter: '' }, ease: 'none', duration: Math.max(0.4, t1.length * 0.045),
        onComplete: function () { line1.classList.remove('is-typing'); if (cycleEl) cycleEl.classList.add('is-typing'); }
      });
    } else if (cycleEl) {
      cycleEl.classList.add('is-typing');
    }

    if (cycleEl) {
      var phrases = (cycleEl.getAttribute('data-phrases') || '').split('|~|').filter(Boolean);
      if (!phrases.length) phrases = [cycleEl.textContent];
      cycleEl.textContent = '';
      var loop = gsap.timeline({ repeat: -1 });
      phrases.forEach(function (ph) {
        loop.to(cycleEl, { text: { value: ph, delimiter: '' }, ease: 'none', duration: Math.max(0.4, ph.length * 0.05) })
            .to({}, { duration: 1.6 })                                   // hold
            .to(cycleEl, { text: { value: '', delimiter: '' }, ease: 'none', duration: Math.max(0.3, ph.length * 0.028) })
            .to({}, { duration: 0.3 });                                  // gap before next
      });
      master.add(loop);   // begins right after line 1 finishes
    }
  }

  function reveal(root, reduce) {
    var items = [].slice.call(root.querySelectorAll('[data-ths-reveal]'));
    if (!items.length) return;
    if (reduce) { gsap.set(items, { autoAlpha: 1 }); return; }
    var title = root.querySelector('.ths__title');
    function play() {
      var tl = gsap.timeline();
      items.forEach(function (el, i) {
        if (el === title && window.SplitText) {
          var split = SplitText.create(el, { type: 'lines', mask: 'lines', linesClass: 'pp-line' });
          tl.from(split.lines, { yPercent: 110, duration: 0.9, ease: 'expo.out', stagger: 0.12, onComplete: function () { split.lines.forEach(function (ln) { if (ln.parentNode) ln.parentNode.style.overflow = 'visible'; }); } }, i * 0.08);
        } else {
          tl.from(el, { autoAlpha: 0, y: 24, duration: 0.7, ease: 'power3.out' }, i * 0.08);
        }
      });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(play); else play();
  }
})();
